import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px 15px 30px;
  background-color: #fff;
  border-radius: 10px;
  max-width: 800px;
  margin: 0px auto;
`;

export const Title = styled.h1`
  margin-bottom: 20px;
  margin-top: 0;
  font-weight: 800;
  font-size: 2em;
  line-height: 1.1;
  color: #212121;
  text-align: center;
`;

export const Subtitle = styled.p`
  margin-bottom: 0;
  margin-top: 0;
  font-weight: 400;
  font-size: 1em;
  line-height: 1.5;
  color: #212121;
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
`;

// description
export const Description = styled.p`
  margin-bottom: 0;
  margin-top: 0;
  font-weight: 400;
  font-size: 1em;
  line-height: 1.5;
  color: #212121;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  width: 100%;
  padding: 15px 0;
`;

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 20px;
  height: 100%;
  padding: 30px 15px;
  width: 100%;
  max-width: 730px;
  margin: 0 auto;
  text-align: center;

  @media only screen and (max-width: 700px) {
    grid-template-columns: auto;
    gap: 40px;
  }
`;

// seperator
export const Seperator = styled.div`
  width: 1px;
  height: 100%;
  background-color: #efeeee;

  @media only screen and (max-width: 700px) {
    display: none;
  }
`;

// label
export const Label = styled.label`
  margin-bottom: 5px;
  display: block;
  font-weight: 400;
  font-size: 1em;
  line-height: 1.1;
  color: #212121;
  text-align: left;
`;

// input
export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
  outline: none;
  transition: border ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

  &:focus,
  &:hover {
    border: 1px solid rgb(63, 63, 63);
  }

  &.is-invalid {
    border-color: #c30344;
  }
`;

// button
export const Button = styled.button`
  background-color: ${({ theme }) => theme.brand.primary};
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  border-radius: 4px;
  width: 100%;

  &:disabled {
    opacity: 0.75;
    cursor: not-allowed;
  }

  &.is-loading {
    svg {
      path {
        fill: ${({ theme }) => theme.brand.primary_text};
      }
      animation: spin 1s linear infinite;
      @keyframes spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    }
  }
`;

// errormessage
export const FieldErrorMessage = styled.p`
  font-weight: 400;
  font-size: 1em;
  line-height: 1.1;
  color: #c30344;
  max-width: 600px;
  text-align: left;
  position: relative;
  display: block;
  opacity: 0;
  transform: translateY(0);
  animation: fadeIn 0.3s ease-in forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(0px);
    }
    to {
      opacity: 1;
      transform: translateY(-10px);
    }
  }
`;

// HelperText
export const HelperText = styled.div`
  font-weight: 400;
  font-size: 1em;
  line-height: 1.1;
  color: #212121;
  max-width: 600px;
  text-align: left;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 5px;
`;

// recaptch wrapper
export const RecaptchaWrapper = styled.div`
  margin-bottom: 20px;
  width: 100%;
  text-align: left;
`;

// error message
export const ErrorMessage = styled.div`
  margin: 10px auto 0;
  font-weight: 400;
  font-size: 1em;
  line-height: 1.1;
  color: #c30344;
  max-width: 600px;
  text-align: left;
  background-color: #ffe7ef;
  width: 100%;
  padding: 10px 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 15px;
  opacity: 0;
  transform: translateY(10px);
  animation: fadeInn 0.3s ease-in forwards;

  @keyframes fadeInn {
    from {
      opacity: 0;
      transform: translateY(0px);
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  svg {
    flex: none;
  }
`;

// formContainer
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
`;
